import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Remove } from "../../../groups";

export const FETCH_DELETE_GROUPS_REQUEST = 'FETCH_DELETE_GROUPS_REQUEST';
export const FETCH_DELETE_GROUPS_SUCCESS = 'FETCH_DELETE_GROUPS_SUCCESS';
export const FETCH_DELETE_GROUPS_FAILURE = 'FETCH_DELETE_GROUPS_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDeleteGroupsRequest = () => {
    return {
        type: FETCH_DELETE_GROUPS_REQUEST,
    };
};

const fetchDeleteGroupsSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DELETE_GROUPS_SUCCESS,
        payload: data
    };
};

const fetchDeleteGroupsFailure = (error: any) => {
    return {
        type: FETCH_DELETE_GROUPS_FAILURE,
        payload: error,
    };
};

export const remove = (id:string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDeleteGroupsRequest());
        try {
            await Remove(id);
            dispatch(fetchDeleteGroupsSuccess(true));
        } catch (error: any) {
            dispatch(fetchDeleteGroupsFailure(error.message));
        }
    };
};
